import { State } from "state/store"

export const getMotifPickerModalOpen = (state: State) =>
  state.ui.motifPickerModalOpen
